/**
 * @description
 * Objeto xmldefs
 */

import { Xmlfields } from "./xmlfields.model";

export class Xmldefs {
    public id:number = null;
    public code:string = "";
    public desc:string;
    public initialtag:string;
    public childrentag:string;
    public title1: Xmlfields = new Xmlfields();
    public title2: Xmlfields = new Xmlfields();
  
    constructor() {}
  
}